<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'strategicContractAdd',
    components: {
      baseEdit,
    },
  };
</script>
